// Rotas conhecidas do app que NAO sao referrers
const KNOWN_ROUTES = ['qualificacao', 'formulario'];

// Função para extrair o referrer da URL (ex: /thiago-boeiras)
// NOTA: Usa pathname (caminho), não conflita com UTMs que usam search (query params)
// Exemplo: /thiago-boeiras?utm_source=google → referrer="thiago-boeiras" + UTMs capturados
export const getReferrerFromUrl = () => {
  const pathname = window.location.pathname;
  // Remove a barra inicial e retorna o referrer se existir
  const referrer = pathname.replace(/^\//, '').trim();
  // Retorna null se estiver vazio, for "/" ou for uma rota conhecida do app
  if (!referrer || referrer === '' || KNOWN_ROUTES.includes(referrer)) return null;
  return referrer;
};

// Função para salvar referrer no localStorage
export const saveReferrer = () => {
  const referrer = getReferrerFromUrl();
  if (referrer) {
    localStorage.setItem('referrer', referrer);
    console.log('Referrer capturado e salvo:', referrer);
  }
};

// Função para recuperar referrer do localStorage
export const getStoredReferrer = () => {
  const storedReferrer = localStorage.getItem('referrer');
  return storedReferrer || null;
};

// Função para verificar se há um novo referrer na URL e atualizar se necessário
export const checkAndUpdateReferrer = () => {
  const urlReferrer = getReferrerFromUrl();
  const storedReferrer = getStoredReferrer();
  
  // Se há um referrer na URL e é diferente do armazenado, atualiza
  if (urlReferrer && urlReferrer !== storedReferrer) {
    saveReferrer();
    return urlReferrer;
  }
  
  // Se não há referrer na URL mas há um armazenado, mantém o armazenado
  return storedReferrer;
};

